import { Transactions } from '../interfaces/Transactions';
import {
    formatDate,
    getTransactionStatus,
    getTransactionType
} from '../utils/helper';
import StatusIndicator from './StatusIndicator';

interface DashboardTableMobileCardProps {
    item?: Transactions;
    onClick?: () => void;
}

const DashboardTableMobileCard = ({
    item,
    onClick = () => {}
}: DashboardTableMobileCardProps) => {
    return (
        <div className='bg-white' onClick={onClick}>
            <div className='flex  gap-[12px] border border-appcolorfaintnine border-b border-0 w-full py-[20px]'>
                <StatusIndicator status={getTransactionStatus(item?.status)} />

                <div>
                    <p className='text-sm font-semibold leading-5 text-ebony mb-[8px]'>
                        {item?.corporateBeneficiaryName}
                    </p>
                    <p className='text-xs font-normal leading-[18px] text-paleSky mb-[4px]'>
                        Tranx:{' '}
                        <span className='font-bold'>
                            {`${item?.fromCurrencyCode}${item?.amountFrom?.toLocaleString()} - ${item?.toCurrencyCode}${item?.amountTo?.toLocaleString()}`}
                        </span>
                    </p>
                    <div className='flex items-center gap-x-4  gap-y-1 flex-wrap mb-[4px] '>
                        <p className='text-xs font-normal leading-[18px] text-paleSky'>
                            Rate:{' '}
                            <span className='font-semibold'>
                                {item?.rateValue}
                            </span>
                        </p>
                        <p className='text-xs font-normal leading-[18px] text-paleSky'>
                            Type:{' '}
                            <span className='font-semibold'>
                                {getTransactionType(item?.transactionType)}
                            </span>
                        </p>
                        <p className='text-xs font-normal leading-[18px] text-paleSky'>
                            Status:{' '}
                            <span className='font-semibold'>
                                {getTransactionStatus(item?.status)}
                            </span>
                        </p>
                    </div>
                    <p className='text-xs font-normal leading-[18px] text-paleSky'>
                        Date:{' '}
                        <span className='font-semibold'>
                            {formatDate(item?.transactionStartDate)}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DashboardTableMobileCard;
